//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @author Rico
import baseFrom from "./baseForm";
export default {
  extends: baseFrom,
  props: {
      submittext: {
        type: String,
        default: "Log in",
      },
    },
  created() {
   
  },
  data() {
    return {
      action: "password-login",
      form: {
        account: "",
        password: "",
      },
    };
  },
};
